<p *ngIf="showErrorMessage" class="error-message">
  <app-icon class="error-icon" [icon]="errorIcon"> </app-icon>

  {{ errorMessage }}
</p>
